import { useCallback, useMemo, useState } from 'react';
import { UserInput } from './UserInput';
const useMergedUserInputsWithMultiplexerOutputs = _ref => {
  let {
    multiplexerOutputs,
    numberOfHistoryItems
  } = _ref;
  const [userInputsToMerge, setUserInputsToMerge] = useState([]);
  const mergedInputsWithOutputs = useMemo(() => {
    const mergedInputsAndOutputs = multiplexerOutputs.map(multiplexerOutput => {
      return {
        type: 'SessionOutput',
        value: multiplexerOutput
      };
    });
    userInputsToMerge.forEach((input, numberOfInputsAlreadyInserted) => {
      mergedInputsAndOutputs.splice(input.indexToInsertInto + numberOfInputsAlreadyInserted, 0, {
        type: 'UserInput',
        value: input.userInput
      });
    });
    return mergedInputsAndOutputs;
  }, [multiplexerOutputs, userInputsToMerge]);
  const addNewUserInputToOutputs = useCallback(_ref2 => {
    let {
      command,
      language
    } = _ref2;
    setUserInputsToMerge(previousUserInputs => previousUserInputs.concat({
      indexToInsertInto: multiplexerOutputs.length > 0 ? multiplexerOutputs.length : 0,
      userInput: new UserInput({
        inputNumber: numberOfHistoryItems + 1,
        language,
        value: command
      })
    }));
  }, [multiplexerOutputs, numberOfHistoryItems]);
  const clearUserInputs = useCallback(() => setUserInputsToMerge([]), []);
  return {
    addNewUserInputToOutputs,
    clearUserInputs,
    mergedInputsWithOutputs
  };
};
export default useMergedUserInputsWithMultiplexerOutputs;